export enum BicReferentialLinks {
  CurrentPage = "getCurrentpage",
  NextPage = "getNextPage",
  PreviousPage = "getPreviousPage",
}
